import { createAsyncThunk } from "@reduxjs/toolkit";
import { API_URL } from "../../../app/config";
import { axiosApiInstance } from "../../../app/axios";
import { ErrorToast, SuccessToast } from "../../../components/toast/Toasts";
import { IAdditionalServiceDetails } from "../additionalserviceModel";

export const getAllAdditionalServices = createAsyncThunk(
  "AdditionalServices/FindAllAdditionalServices",
  async () => {
    try {
      const response = await axiosApiInstance.post(
        `${API_URL}/AdditionalServices/FindAllAdditionalServices`,
        {
          ServiceName: "",
        }
      );
      return response.data?.Data;
    } catch (error: any) {
      // ErrorToast(error?.response?.data?.Details || "Something went wrong");
      console.error("Error Fetching AdditionalService:", error);
      return Promise.reject({
        message: error?.response?.data?.Details || "Something went wrong",
      });
    }
  }
);

export const getAllActiveAdditionalServices = createAsyncThunk(
  "AdditionalServices/FindAllActiveAdditionalServices",
  async () => {
    try {
      const response = await axiosApiInstance.get(
        `${API_URL}/AdditionalServices/FindAllActiveAdditionalServices`
      );
      return response.data?.Data;
    } catch (error: any) {
      // ErrorToast(error?.response?.data?.Details || "Something went wrong");
      console.error("Error Fetching AdditionalService:", error);
      return Promise.reject({
        message: error?.response?.data?.Details || "Something went wrong",
      });
    }
  }
);

export const createAdditionalService = createAsyncThunk(
  "AdditionalServices/InsertAdditionalServices",
  async (formData: any) => {
    try {
      const response = await axiosApiInstance.post(
        `${API_URL}/AdditionalServices/InsertAdditionalServices`,
        formData
      );
      SuccessToast(response.data?.Details || "Success");
      return response.data;
    } catch (error: any) {
      ErrorToast(error?.response?.data?.Details || "Something went wrong");
      console.error("Error creating AdditionalServices:", error);
      return Promise.reject({
        message: error?.response?.data?.Details || "Something went wrong",
      });
    }
  }
);

export const updateAdditionalService = createAsyncThunk(
  "AdditionalServices/UpdateAdditionalServices",
  async (formData: any) => {
    try {
      const response = await axiosApiInstance.post(
        `${API_URL}/AdditionalServices/UpdateAdditionalServices`,
        formData
      );
      SuccessToast(response.data?.Details || "Success");
      return response.data;
    } catch (error: any) {
      ErrorToast(error?.response?.data?.Details || "Something went wrong");
      console.error("Error updating AdditionalService:", error);
      return Promise.reject({
        message: error?.response?.data?.Details || "Something went wrong",
      });
    }
  }
);

export const getAdditionalServiceByID = createAsyncThunk(
  "AdditionalServices/FindByIDAdditionalServices",
  async (ID: number) => {
    try {
      const response = await axiosApiInstance.post(
        `${API_URL}/AdditionalServices/FindByIDAdditionalServices`,
        { ID }
      );
      const result = response.data?.Data as any;
      return {
        ID: result?.ID,
        VisaCountryID: result?.VisaCountryID ? +result?.VisaCountryID : null,
        VisaCountry: result?.VisaCountry,
        ServiceName:result?.ServiceName,
        ServiceDescription:result?.ServiceDescription,
        Price: result?.Price ? +result?.Price : null,
        IsActive: result?.IsActive ? 1 : 2,
      } as IAdditionalServiceDetails;
    } catch (error: any) {
      ErrorToast(error?.response?.data?.Details || "Something went wrong");
      console.error("Error fetching AdditionalServices:", error);
      return Promise.reject({
        message: error?.response?.data?.Details || "Something went wrong",
      });
    }
  }
);

export const additionalServiceActiveInactive = createAsyncThunk(
  "AdditionalServices/ActiveInActiveAdditionalServices",
  async (formData: any) => {
    try {
      const response = await axiosApiInstance.post(
        `${API_URL}/AdditionalServices/ActiveInActiveAdditionalServices`,
        formData
      );
      SuccessToast(response.data?.Details || "Success");
      return response.data;
    } catch (error: any) {
      ErrorToast(error?.response?.data?.Details || "Something went wrong");
      console.error("Error active-inactive AdditionalServices:", error);
      return Promise.reject({
        message: error?.response?.data?.Details || "Something went wrong",
      });
    }
  }
);

export const deleteAdditionalService = createAsyncThunk(
  "AdditionalServices/DeleteAdditionalServices",
  async (ID: number) => {
    try {
      const response = await axiosApiInstance.post(
        `${API_URL}/AdditionalServices/DeleteAdditionalServices`,
        { ID }
      );
      SuccessToast(response.data?.Details || "Success");
      return response.data;
    } catch (error: any) {
      ErrorToast(error?.response?.data?.Details || "Something went wrong");
      console.error("Error deleting AdditionalServices:", error);
      return Promise.reject({
        message: error?.response?.data?.Details || "Something went wrong",
      });
    }
  }
);
